<div class="disk-ui-wrapper">
  <div class="disk-ui-type">
    {{ data.type ? data.type : 'HDD' }}
  </div>
  <div class="disk-ui-icon">
    <ix-icon class="disk-icon" name="mdi-harddisk"></ix-icon>
  </div>
  <div class="disk-ui-name">
    {{ data.name }}
  </div>
</div>
